import { Matrix as m, Quaternion as R, Vector3 as a } from "@babylonjs/core/Maths/math.vector.js";
function u(n) {
  return n?.getSessionDocumentRoot() ?? null;
}
function s(n) {
  return u(n) ?? n?.getSceneRoot() ?? null;
}
function h(n) {
  return s(n)?.getChildren() ?? [];
}
function c(n) {
  return !!n && n.traceScene.getSceneRoot() === n;
}
function f(n) {
  return !!n && u(n.traceScene) === n;
}
function P(n) {
  return c(n) || f(n);
}
function C(n, t) {
  if (!n) return null;
  const e = t === "delete" ? "deleted" : t === "move" ? "reparented" : "duplicated";
  return f(n) ? `"${n.name}" is the root of this document and cannot be ${e} — rename or transform it instead (SCENE_ROOT_SPEC D8)` : c(n) ? `The engine scene root cannot be ${e} — it is a runtime mount point, not a node (SCENE_ROOT_SPEC D8)` : null;
}
var l = /* @__PURE__ */ new WeakSet();
function g(n, t = s(n.traceScene)) {
  for (let o = t; o; o = o.getParent()) if (o === n) return;
  if (!t) return;
  n.getParent() !== t && n.setParent(t);
  const e = new a(), r = new R(), i = new a();
  m.Invert(S(t.transform)).decompose(i, r, e), n.transform.position.copyFrom(e), n.transform.rotationQuaternion = r, n.transform.scaling.copyFrom(i), l.add(n);
}
function O(n) {
  for (const t of d(n)) g(t, t.getParent());
}
function d(n) {
  return n.getChildren().flatMap((t) => p(t) ? [t] : d(t));
}
function p(n) {
  return !!n && l.has(n);
}
function S(n) {
  const t = [];
  for (let e = n; e; e = e.parent) t.unshift(e);
  for (const e of t) e.computeWorldMatrix(!0);
  return n.getWorldMatrix().clone();
}
export {
  P as a,
  C as c,
  c as i,
  h as l,
  d as n,
  g as o,
  p as r,
  O as s,
  u as t,
  s as u
};

//# sourceMappingURL=documentRoot-BRVSd6Oa.js.map